import { useState } from "react";
import PageHero from "@/components/PageHero";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { SITE_META } from "@/lib/site";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const supportEmail = SITE_META.emails?.support;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/contact", { ...form, site: SITE_META.site });
      toast.success("Message sent. We'll be in touch.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Could not send message."); }
    finally { setBusy(false); }
  };

  return (
    <>
      <PageHero
        eyebrow="/ Contact"
        title="Send a signal."
        subtitle="Researchers, educators, journalists, and citizens welcome. Tell us what you're building, observing, or asking about."
        image="https://images.pexels.com/photos/30037318/pexels-photo-30037318.jpeg"
      />
      <section className="py-24 md:py-32 px-6 md:px-10 max-w-3xl mx-auto">
        <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[color:var(--np-muted)]">Name</label>
              <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full mt-2 bg-transparent border-b border-black/15 focus:border-[color:var(--np-live)] outline-none py-3 text-lg" data-testid="contact-name-input" />
            </div>
            <div>
              <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[color:var(--np-muted)]">Email</label>
              <input required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full mt-2 bg-transparent border-b border-black/15 focus:border-[color:var(--np-live)] outline-none py-3 text-lg" data-testid="contact-email-input" />
            </div>
          </div>
          <div>
            <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[color:var(--np-muted)]">Subject</label>
            <input required value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} className="w-full mt-2 bg-transparent border-b border-black/15 focus:border-[color:var(--np-live)] outline-none py-3 text-lg" data-testid="contact-subject-input" />
          </div>
          <div>
            <label className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-[color:var(--np-muted)]">Message</label>
            <textarea required rows={6} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} className="w-full mt-2 bg-transparent border border-black/15 focus:border-[color:var(--np-live)] outline-none p-4 text-lg resize-none" data-testid="contact-message-input" />
          </div>
          <button disabled={busy} className="font-mono-tech text-[11px] tracking-[0.3em] uppercase border border-black/15 hover:bg-[color:var(--np-text)] hover:text-[color:var(--np-bg)] px-8 py-4 transition-colors" data-testid="contact-submit-btn">
            {busy ? "Sending…" : "Send message"}
          </button>
        </form>
        {supportEmail && (
          <p className="mt-10 text-sm text-[color:var(--np-muted)]" data-testid="contact-support-email">
            Prefer email? Write to{" "}
            <a className="underline" href={`mailto:${supportEmail}`}>{supportEmail}</a>.
          </p>
        )}
      </section>
    </>
  );
}
